import DateRanger from './DateRanger';

export default DateRanger;